import { HStack, Text, useColorModeValue } from '@chakra-ui/react';
import type { Country } from '@/models/country';
import type { LiveMatchEvent } from '@/models/liveMatch';
import { formatLiveEventMinute } from '@/helpers/fixtures/liveMatchDisplay';
import { Flag } from '../Flag';

export function MatchEventRow(props: {
  event: LiveMatchEvent;
  homeTeam: Country;
  awayTeam: Country;
}) {
  const metaColor = useColorModeValue('gray.600', 'gray.400');
  const team = props.event.side === 'home' ? props.homeTeam : props.awayTeam;
  const minute = formatLiveEventMinute(props.event.minute, props.event.minuteExtra);

  let label = props.event.player;
  if (props.event.type === 'goal') {
    label = props.event.assist
      ? `${props.event.player} (${props.event.assist})`
      : props.event.player;
    if (props.event.detail === 'Own Goal') {
      label = `${props.event.player} (OG)`;
    }
  } else if (props.event.type === 'card') {
    label = `🟥 ${props.event.player}`;
  }

  return (
    <HStack spacing={2} align='center' w='full' fontSize='xs' lineHeight='1'>
      <Text flexShrink={0} fontWeight='semibold' w='2.5rem' textAlign='left'>
        {minute}
      </Text>
      <Flag country={team} w={4} h={3} borderRadius='2px' flexShrink={0} svg />
      <Text color={metaColor} lineHeight='short'>
        {label}
      </Text>
    </HStack>
  );
}
